"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemeFromData = void 0;
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
/**
 * Сгененрировать файл темы из объекта с произвольной структурой.
 */
var generateThemeFromData = function (data, fileName) {
    return (0, generateFile_1.generateFile)(fileName, (0, utils_1.attachToRoot)((0, utils_1.objectToCSSVariables)(data)));
};
exports.generateThemeFromData = generateThemeFromData;
//# sourceMappingURL=generateThemeFromData.js.map